<template>
  <v-list class="overflow-y-auto" style="background-color: var(--color-bg)">
    <template v-for="(issue, index) in sensorIssues">
      <v-list-item :key="index">
        <v-list-item-content>
          <v-list-item-title class="title mb-2">
            {{ issue.sensorName }}
          </v-list-item-title>

          <v-row>
            <v-col cols="6">
              <v-list-item-subtitle class="mb-1 subtitle">
                <span class="font-weight-bold">Fault Type:</span>
                {{ issue.faultType }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="mb-1 subtitle">
                <span class="font-weight-bold">Date:</span>
                {{ issue.registeredDateString }}
              </v-list-item-subtitle>
            </v-col>
            <v-col cols="6">
              <v-list-item-subtitle class="mb-1 subtitle">
                <span class="font-weight-bold">Value:</span>
                {{ formattedValue(issue) }}%
              </v-list-item-subtitle>
              <v-list-item-subtitle class="mb-1 subtitle">
                <span class="font-weight-bold">Limit:</span>
                {{ issue.checkLimit.toFixed(1) }}%
              </v-list-item-subtitle>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>

      <v-divider
        v-if="index < sensorIssues.length - 1"
        :key="`divider-${index}`"
        style="background-color: var(--color-border)"
      />
    </template>
  </v-list>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "SensorIssuesSuccessView",
  data: function () {
    return {};
  },
  computed: {
    ...mapState("sensorIssues", ["sensorIssues"]),
    formattedValue() {
      return (issue) => {
        return issue.checkValue.toFixed(1);
      };
    },
    issueColor() {
      return (issue) => {
        const deviation = +issue.percentageLimitDeviation;
        if (deviation < 5) return "green";
        if (deviation > 10) return "red";
        return "orange";
      };
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 1.5rem;
  color: var(--color-text) !important;
  font-weight: 600;
}

.subtitle {
  color: var(--color-text-muted) !important;
}
</style>

